module.exports = __webpack_public_path__ + "static/social-display-ads-plant-2-497e6baae92d7a6855da2ab2cff00d22.svg";